export const REGION_CODES = ['AU', 'US', 'UK', 'NZ'];

export const REGION_LABELS = {
  AU: 'Australia',
  US: 'United States',
  UK: 'United Kingdom',
  NZ: 'New Zealand',
};
